module.exports = __webpack_public_path__ + "static/creativity-4e734d306b8ac03e0a4e57c3b8c4eaa0.svg";